// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function TankManagementTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Tank Management</p>
      <p>
        Manage fertigation inventory — stock tank recipes, batch mixes for irrigation events, and
        your bulk fertilizer product library with pricing.
      </p>
      <div>
        <p className="font-medium">Sections</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Stock tanks — log concentrate recipes and track component inventory</li>
          <li>Batch tanks — document mixes with EC, pH, volume, and target rooms</li>
          <li>Fertilizers — register bulk products with NPK, unit weight, and cost</li>
        </ul>
      </div>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Register fertilizers first, then build stock tank recipes from them.</li>
          <li>Use batch tanks to log each mix before irrigating.</li>
          <li>Review insights for mix frequency, cost, and predicted next batch dates.</li>
        </ol>
      </div>
      <p className="text-muted-foreground">
        Stock recipes feed batch logging — keep fertilizers current for accurate cost tracking.
      </p>
    </div>
  );
}
